import { Paso } from './Paso';

export type { TypePasoProps } from './types';
export default Paso;
